/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, {useEffect, useState, useRef} from "react";
import {Link} from "react-router-dom";
import {withTranslation} from "react-i18next";

import {Grid, Box} from "@material-ui/core";
import {useThemeData} from "../../context/ThemeDataContext";
import {usePhotoBaseData} from "../../context/PhotoBasicDataContext";
import GeneralButton from "../Buttons";
import IconButton from '@material-ui/core/IconButton';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import PhotoGridHome from './PhotoGridHome';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import loadImage from "../../loader.svg";

function PhotosComponent(props) {
    const {site_id} = useThemeData().themeData.site;
    const {
        border_radius, border_radius_2, background_color_7, background_color_5,
    } = useThemeData().themeData.site.theme;
    const {category_id, setCategoryID} = useThemeData().categoryData;
    const {hide_photo_overview, hide_category_side_bar} = useThemeData().modules;
    const PHOTO_URL = process.env.REACT_APP_PHOTO_URL;
    const [photos, setPhotos] = useState(false);
    const [link, setLink] = useState("");
    const [groupPhotos, setGroupPhotos] = useState({photos: false});
    const [pakketGroupPhotos, setPakketGroupPhotos] = useState({photos: false});
    const changedPhoto = props.changedPhoto ? props.changedPhoto : undefined;
    const props_photos = usePhotoBaseData().photoData;
    const {default_photo_id} = usePhotoBaseData().photoDefaultSettings;
    const select_photo = default_photo_id;

    const sliderRef = useRef(null);
    const [scrollPosition, setScrollPosition] = useState(0);

    const handleScrollLeft = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollLeft -= sliderRef.current.offsetWidth;
            setScrollPosition(sliderRef.current.scrollLeft);
        }
    };

    const handleScrollRight = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollLeft += sliderRef.current.offsetWidth;
            setScrollPosition(sliderRef.current.scrollLeft);
        }
    };

    useEffect(() => {
        if (props_photos[0] !== undefined) {
            setPhotos(true);
        }
    }, [props_photos]);

    useEffect(() => {
        if (photos === true && setCategoryID !== undefined) {
            if (changedPhoto === undefined) {
                setLink(props_photos[0].id);
                setCategoryID(category_id);
            } else {
                setLink(changedPhoto.id);
                setCategoryID(changedPhoto.categorie_id);
            }
        }
    }, [photos, changedPhoto, props_photos, setCategoryID, category_id]);

    useEffect(() => {
        //pakket groepsfotos
        if (props.groepsfoto === true) {
            if (photos === true && pakketGroupPhotos.photos === false) {
                setPakketGroupPhotos((prevState) => ({
                    ...prevState, photos: props_photos.filter((photo) => photo.type === "groep"),
                }));
            }
        }
    }, [props.groepsfoto, photos, props_photos, pakketGroupPhotos]);

    useEffect(() => {
        if (photos === true && groupPhotos.photos === false) {
            props_photos
                .filter((photo) => photo.type === "groep")
                .map((photos) => {
                    return setGroupPhotos((prevState) => ({
                        ...prevState, photos: photos,
                    }));
                });
        }
    }, [photos, props_photos, groupPhotos]);

    function doesFileExist(urlToFile) {
        var xhr = new XMLHttpRequest();
        xhr.open('HEAD', urlToFile, false);
        xhr.send();

        if (xhr.status === 404) {
            // console.log("File doesn't exist");
            return false;
        } else {
            // console.log("File exists");
            return true;
        }
    }

    const renderPhotoGrid = () => {
        return (<PhotoGridHome
                photos={props_photos}
                selectPhoto={select_photo}
                siteId={site_id}
                backgroundColors={{color5: background_color_5, color7: background_color_7}}
                borderRadius={border_radius_2}
                changePhoto={props.changePhoto}
                t={props.t}
            />);
    };

    const checkAndReturnImage = (photo) => {
        const imageExists = doesFileExist(`${PHOTO_URL}${site_id}/${photo.folder.folder_id}/0/0/0/0/${photo.id}/${photo.file_name}/${props.product_child_id}/${props.product_id}`);

        if (!imageExists) {
            return null;
        }

        return (<div className="col-12 text-center" key={photo.id}>
      <span
          className="no-padding"
          style={{cursor: "pointer"}}
          onClick={() => props.closePopup(photo.file_name, photo.id, photo.id, photo.folder.folder_id)}
      >
      <LazyLoadImage
          src={`${PHOTO_URL}${site_id}/${photo.folder.folder_id}/0/0/0/0/${photo.id}/${photo.file_name}`}
          alt={photo.file_name}
          className="small-image-size"
          placeholderSrc={loadImage}
          style={{
              border: `1px solid ${background_color_5}`,
              maxWidth: "30%",
              maxHeight: "30%",
          }}
      />
      </span>
            </div>);
    };

    if (props.productdetailType === 1) {
        return (<Grid className="justify-content-center">
                {pakketGroupPhotos.photos !== false ? pakketGroupPhotos.photos
                    //to do way we need to filter this?
                    // .filter(photo => photo.class_id === props.class_id)
                    .map(checkAndReturnImage) : props_photos
                  .filter(photo => {
                      // First condition: Check if type is not "groep" and other conditions
                      const typeAndLoginCheck = photo.type !== "groep" && (props.pakket_selectie_alle_inlogs === 'nee' ? props.login_name === photo.login_name : true);

                      // If the first condition fails, check if folder_id is one of the desired values
                      const folderCheck = (photo.folder.folder_id === '124003124' || photo.folder.folder_id === '157397747');

                      // Log the results for debugging
                      // console.log("Checking photo:", photo);
                      // console.log("Type and login check:", typeAndLoginCheck);
                      // console.log("Folder check:", folderCheck);

                      // Return true if either the type/login condition is true, or if the folder_id matches the fallback condition
                      return typeAndLoginCheck || folderCheck;
                  })
                    .map(checkAndReturnImage)}
            </Grid>);
    }
    //home
    if (props.highlight === true && photos === true) {
        //hightlighted photo on homepage
        if (changedPhoto !== undefined && link) {
            return (<Grid container
                          style={{
                              borderRadius: `${border_radius} ${border_radius} ${border_radius} ${border_radius}`,
                          }}
                >
                    <Grid item
                          xs={12}
                          sm={12}
                          md={12}
                          className="text-center"
                          style={{marginBottom: `15px`}}
                    >
                        {link && (<Link
                                style={{float: `left`, width: "100%"}}
                                to={{
                                    pathname: `/shoppage/photo_id/${link}`, state: {
                                        photo_id: link,
                                        folder_id: changedPhoto.folderID,
                                        photo_file_name: changedPhoto.filename,
                                    },
                                }}
                                className="photos image-link"
                            >
                                {(() => {
                                    if (select_photo === changedPhoto.id) {
                                        return (<img
                                                style={{
                                                    border: `1px solid ${background_color_5}`, height: 400,
                                                }}
                                                alt={changedPhoto.filename}
                                                src={`${PHOTO_URL}${site_id}/${changedPhoto.folderID}/0/0/0/0/${changedPhoto.id}/${changedPhoto.filename}`}
                                                className="small-image-size image-home img-sizing home1"
                                            />);
                                    }
                                    if (changedPhoto.id !== props_photos[0].file_name && changedPhoto.id === "") {
                                        return (<img
                                                style={{
                                                    border: `1px solid ${background_color_5}`, height: 400,
                                                }}
                                                alt={props_photos[0].file_name}
                                                src={`${PHOTO_URL}${site_id}/${props.folder.folder_id}/0/0/0/0/${props.id}/${props_photos[0].file_name}`}
                                                className="small-image-size image-home img-sizing home2"
                                            />);
                                    } else {
                                        return (<img
                                                style={{
                                                    border: `1px solid ${background_color_5}`, height: 400,
                                                }}
                                                alt={changedPhoto.filename}
                                                src={`${PHOTO_URL}${site_id}/${changedPhoto.folderID}/0/0/0/0/${changedPhoto.id}/${changedPhoto.filename}`}
                                                className="small-image-size image-home img-sizing changedPhoto"
                                            />);
                                    }
                                })()}
                                <div
                                    className="image-overlay"
                                    style={{backgroundColor: `${background_color_5}`}}
                                >
                                    <div className="image-text">
                                        <GeneralButton className="width-max-content align-around 1">
                                            {props.t("photosComponent:View your photo")}
                                        </GeneralButton>
                                    </div>
                                </div>
                            </Link>)}
                    </Grid>
                </Grid>);
        } else {
            if (hide_photo_overview === 'true') {
                props.history.push({
                    pathname: `/shoppage/photo_id/${props_photos[0].id}/${props_photos[0].productcategory[0].categorie_id}`,
                    state: {
                        photo_id: props_photos[0].id,
                        folder_id: props_photos[0].folder.folder_id,
                        photo_file_name: props_photos[0].file_name,
                        categorie_id: props_photos[0].productcategory[0].categorie_id,
                    },
                });
            }
            return (<Grid container
                          style={{
                              borderRadius: `${border_radius} ${border_radius} ${border_radius} ${border_radius}`,
                          }}
                >
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        className="text-center"
                        style={{marginBottom: `15px`}}
                    >
                        <Link
                            style={{float: `left`, width: "100%"}}
                            to={{
                                pathname: `/shoppage/photo_id/${props_photos[0].id}/${props_photos[0].productcategory[0].categorie_id}`,
                                state: {
                                    photo_id: props_photos[0].id,
                                    folder_id: props_photos[0].folder.folder_id,
                                    photo_file_name: props_photos[0].file_name,
                                    categorie_id: props_photos[0].productcategory[0].categorie_id,
                                },
                            }}
                            className="photos image-link"
                            onClick={() => setCategoryID(props_photos[0].productcategory[0].categorie_id)}
                        >
                            {(() => {
                                if (select_photo === props_photos[0].id) {
                                    return (<img
                                            style={{
                                                border: `1px solid ${background_color_5}`, height: 400,
                                            }}
                                            alt={props_photos[0].file_name}
                                            src={`${PHOTO_URL}${site_id}/${props_photos[0].folder.folder_id}/0/0/0/0/${props_photos[0].id}/${props_photos[0].file_name}`}
                                            className="small-image-size image-home img-sizing"
                                        />);
                                }
                            })()}
                            <div
                                className="image-overlay"
                                style={{backgroundColor: `${background_color_5}`}}
                            >
                                <div className="image-text">
                                    <GeneralButton className="width-max-content align-around 2">
                                        {props.t("photosComponent:View your photo")}
                                    </GeneralButton>
                                </div>
                            </div>
                        </Link>
                    </Grid>
                </Grid>);
        }
    } else return (//small photos on shoppage
        props.thumbnail ? (hide_category_side_bar !== 'true' ? (
                <Grid container direction="row" className="margin-top-bottom-1 thumb-container">
                    <IconButton onClick={handleScrollLeft} disabled={scrollPosition === 0}>
                        <ArrowBackIosIcon/>
                    </IconButton>

                    <Box
                        ref={sliderRef}
                        display="flex"
                        height="100%"
                        className="thumbnail-slider scroll-body"
                        style={{
                            border: "1px solid rgb(217 218 219)",
                            borderRadius: `${border_radius} ${border_radius} ${border_radius} ${border_radius}`,
                        }}
                    >
                        {props_photos && props_photos.length > 0 ? props_photos.slice().map((photo) => {
                            let categorie_id = photo.productcategory[0].categorie_id;
                            if (category_id !== null && category_id !== undefined && photo.type === 'portret') {
                                categorie_id = category_id;
                            }

                            return (<div className="slider-thumb" key={photo.id}>
                                    <Link
                                        key={photo.id}
                                        to={{
                                            pathname: category_id != null ? `/shoppage/photo_id/${photo.id}/${categorie_id}` : `/shoppage/photo_id/${photo.id}`,
                                            state: {
                                                photo_id: photo.id,
                                                folder_id: photo.folder.folder_id,
                                                photo_file_name: photo.file_name,
                                                categorie_id: categorie_id
                                            },
                                        }}
                                    >
                                        <div>
                                            <LazyLoadImage
                                                src={`${PHOTO_URL}${site_id}/${photo.folder.folder_id}/0/0/0/0/${photo.id}/${photo.file_name}`}
                                                alt={photo.file_name}
                                                className="image small-image-size"
                                                placeholderSrc={loadImage}
                                            />
                                            <div
                                                className="image-overlay"
                                                style={{backgroundColor: `${background_color_5}`}}
                                            ></div>
                                        </div>
                                    </Link>
                                </div>)
                        }) : null}
                    </Box>

                    <IconButton onClick={handleScrollRight}>
                        <ArrowForwardIosIcon/>
                    </IconButton>
                </Grid>) : null) : (//small photos and groupphotos on homepage
            renderPhotoGrid()));
}

export default React.memo(withTranslation("message, photosComponent")(PhotosComponent));
